import { useQuery } from '@tanstack/react-query';
import { logger } from "@/utils/logger";
import { db } from '@/lib/supabaseQuery';

interface SearchSuggestion {
  id: string;
  suggestion_text: string;
  source_type: string;
  frequency: number;
}

interface PopularSearchRow {
  id: string;
  suggestion_text: string;
  source_type: string;
  frequency: number;
}

/**
 * Popular/trending searches aggregated from real `search_submit` analytics
 * events via the get_popular_searches RPC (last 30 days; trending = last 7).
 */
export function useSearchSuggestions(limit = 10) {
  return useQuery({
    queryKey: ['search-suggestions', limit],
    queryFn: async (): Promise<SearchSuggestion[]> => {
      const { data, error } = await db.raw.rpc('get_popular_searches', { p_limit: limit });

      if (error) {
        logger.error('[useSearchSuggestions] Error:', error);
        return [];
      }

      return ((data as PopularSearchRow[] | null) ?? []).map((row) => ({
        id: row.id,
        suggestion_text: row.suggestion_text,
        source_type: row.source_type,
        frequency: Number(row.frequency),
      }));
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
